var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HMModalHeader',{attrs:{"title":_vm.$t('PRODUCTS.TITLE.REVIEW')},on:{"close":_vm.close}}),_c('ProductReviewCard',{attrs:{"review":_vm.review,"primaryColor":_vm.teacher.primary_color,"iconType":_vm.teacher.rating_icon_type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }